import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { EmrReportsService } from '../emr-report.service';
import { SelectizeComponent, ToastService } from '../../../blocks';
import { takeUntil } from 'rxjs/operators';
import { SharedDateService, SheetParms, UIAction, UserSessionService } from '../../../shared';
import { DevExpressHelperComponent } from '../../../blocks/dev-express-viewer/dev-express-helper.component';
import { EmrHtmlTemplatesService } from '../../../pat-html-reports/emr-html-templates/emr-html-templates.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-emr-rad-report',
  templateUrl: './emr-rad-report.component.html',
  styleUrls: ['./emr-rad-report.component.css']
})
export class EmrRadReportComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  devExpressHelperComponent: DevExpressHelperComponent;
  _SearchParms: any = {};
  textContent: any;
  visitSerial: number;
  patCode: number;
  regPatServiceSerial: number;
  serviceCode: number;
  emrHtmlTemplateSerial: number;
  emrHtmlReportSerial: number;
  patientReports: any = [];
  reportType: number;
  filterText: string = '';
  serviceType: number;
  mode: number;
  @ViewChild('patientSelectize') patientSelectize: SelectizeComponent;
  @ViewChild('visitSelectize') visitSelectize: SelectizeComponent;
  @ViewChild('serviceSelectize') serviceSelectize: SelectizeComponent;
  @ViewChild('htmlTemplate') htmlTemplate: SelectizeComponent;

  constructor(
    public translate: TranslateService,
    private _emrReportsService: EmrReportsService,
    private _emrHtmlTemplatesService: EmrHtmlTemplatesService,
    private _toaster: ToastService,
    private _dateSer: SharedDateService,
    private route: ActivatedRoute,
    private userSession: UserSessionService

  ) {
    this.devExpressHelperComponent = new DevExpressHelperComponent;

  }

  ngOnInit() {
    //  1- rad  2- lab
    this.mode = +this.route.snapshot.params['mode'];
    this.serviceType = this.mode;
  }
  /////////////////////dropdown area//////////////////////
  onPatientClicked(selectedItem: any): void {
    this.patCode = null;
    if (selectedItem && selectedItem != null) {
      this.visitSelectize.setFastSearchKey('ParentId', selectedItem.code);
      this.patCode = selectedItem.code
    } else {
      if (this.visitSelectize)
        this.visitSelectize.setFastSearchKey('ParentId', null);
    }
    if (this.visitSelectize) {
      this.visitSelectize.clearItems();
      this.visitSelectize.clear();
      this.serviceSelectize.clearItems();
      this.serviceSelectize.clear();
    }
  }
  onVisitClicked(selectedItem: any): void {
    this.visitSerial = null;
    if (selectedItem && selectedItem != null) {
      this.serviceSelectize.setFastSearchKey('ParentId', selectedItem.code);
      this.visitSerial = selectedItem.code;
    }
    else {
      if (this.serviceSelectize)
        this.serviceSelectize.setFastSearchKey('ParentId', null);
    }
    if (this.serviceSelectize) {
      this.serviceSelectize.clearItems();
      this.serviceSelectize.clear();
    }
  }
  resetParams() {
    this.emrHtmlReportSerial = null;
    this.textContent = '';
    this.visitSerial = null;
    this.regPatServiceSerial = null;
  }
  setParams(params) {
    this.emrHtmlReportSerial = params.emrHtmlReportSerial;
    this.textContent = params.contentAsText;
    this.visitSerial = params.visitSerial;
    this.regPatServiceSerial = params.regPatServiceSerial;
    this.patCode = params.patCode;
  }
  onPatServiceClick(ser: any, e: any) {
    this.resetParams();
    if (ser.regPatServiceSerial > 0) {
      this.setParams(ser);
      if (!ser.emrHtmlReportSerial) {
        this.textContent = ser.patReportStatus
      }
    }
    this.userSession.setSessionKey('patientBanner', ser);
  }
  onServiceClicked(selectedItem: any): void {
    this.regPatServiceSerial = null;
    if (selectedItem && selectedItem != null) {
      this.regPatServiceSerial = selectedItem.code;
    }
  }

  //////////////////////
  hasReportFlag: number;
  onHasReportFlagClicked(selectedItem: any) {
    this.regPatServiceSerial = null;
    if (selectedItem && selectedItem != null) {
      this.hasReportFlag = selectedItem.code;
      console.log("hasReportFlag = ", this.hasReportFlag);

    }
  }


  ////////////////////////actoin//////////
  onBtnClicked(e: number): void {
    switch (e) {
      case 1: //save code
      case -1000:
        this.saveReport();
        break;
      case 639:
        this.printReport();
        break
      case 565:
        this.saveReport();
        break

    }
  }

  allPatientServices: any = []
  filterdArr: any = []
  allPatientServicesbuffer: any = []


  filterServices() {
    if (this.filterText.trim() !== '') {
      this.allPatientServices = this.filterdArr.filter(item =>
        (item.serviceNameAr && item.serviceNameAr.includes(this.filterText)) ||
        (item.serviceId
          && item.serviceId
            .toString().includes(this.filterText))
        ||
        (item.serviceNameEn
          && item.serviceNameEn
            .toString().includes(this.filterText)

        )
        ||
        (item.patReportStatus.toString().includes(this.filterText)
        )

      );
    }
    else {
      this.allPatientServices = this.allPatientServicesbuffer
    }
  }

  searchPatientServices() {   // الخدمات نوعها يكون ليها قالب   EmrHtmlReports.ReportType = 100
    this.textContent = '';
    this.filterText = '';
    let searchParams = <SheetParms>{
      patCode: this.patCode,
      visitSerial: this.visitSerial,
      RegPatServiceSerial: this.regPatServiceSerial,
      hasReportFlag: this.hasReportFlag,
      fromDate: this._dateSer.convertFromNgBsToDate(this._SearchParms.fromDate),
      toDate: this._dateSer.convertFromNgBsToDate(this._SearchParms.toDate),
      serviceType: this.mode // 1 - Lab 2 - Rad
    };
    this.userSession.setSessionKey('patientBanner', searchParams);
    console.log("searchParams = ", searchParams)
    this.allPatientServices = [];
    this._emrReportsService.getPatientUltrasoundServices(searchParams)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res) {
            if (res.data && res.data.length > 0) {
              this.allPatientServices = res.data;
              this.allPatientServicesbuffer = res.data;
              this.filterdArr = res.data;
            }
          }
        });
  }
  searchForReportTemplate() {
    let searchParams = <SheetParms>{
      serial: this.emrHtmlReportSerial,
      RegPatServiceSerial: this.regPatServiceSerial
    };
  }
  onTemplateSelect(item: any) {

    if ((item != null && item['AutoEmited'] == false) || (item != null && item.emrHtmlTemplatesSerial)) {
      this.emrHtmlTemplateSerial = item.code ? item.code : item.emrHtmlTemplatesSerial;
      this._emrHtmlTemplatesService.getEmrHtmlTemplates(this.emrHtmlTemplateSerial)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res && res.data && res.data.length > 0) {
              var convertHtmlContent = res.data[0]['htmlContent'].replace(/<[^>]*>/g, '');
              var finalRepRemplate = convertHtmlContent.replace(/\&nbsp;/g, '');
              this.textContent = finalRepRemplate;
            }
          },
          error => console.log(error),
          () => {
            //this.getReportData();
          });
    }

  }
  saveReport() {
    ////////////////Edit
    if (!this.textContent || this.textContent == '') {
      this._toaster.activateMsg("Enter Report")
      return
    }
    let emrHtmlReport = <SheetParms>{
      serial: this.emrHtmlReportSerial ? this.emrHtmlReportSerial : 0,
      patCode: this.patCode,
      visitSerial: this.visitSerial,
      reportType: this.reportType ? this.reportType : 1,
      htmlContent: '<div>' + this.textContent + '</div>',
      emrHtmlTemplatesSerial: this.emrHtmlTemplateSerial,
      RegPatServiceSerial: this.regPatServiceSerial,
      textContent: this.textContent

    };
    ////////////New
    if (!this.patCode) {
      this._toaster.activateMsg("Enter Patient")
      return
    }
    if (!this.visitSerial) {
      this._toaster.activateMsg("Enter Visit")

      return
    }
    if (!this.regPatServiceSerial) {
      this._toaster.activateMsg("Enter Service")

      return
    }
    if (!this.textContent || this.textContent == '') {
      this._toaster.activateMsg("Enter Report")
      return
    }
    if (this.emrHtmlReportSerial == 0 || !this.emrHtmlReportSerial) {
      this._emrReportsService.addWrittenReports(emrHtmlReport)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res) {
              if (res.data && res.data.length > 0) {
                this.emrHtmlReportSerial = res.data[0].emrHtmlReportsSerial;
              }

              this.resetParams();


            }
          });
    }
    else {
      this._emrReportsService.updateWrittenReports(emrHtmlReport)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            this.printReport();
            this.resetParams();
            this.searchPatientServices();
          });
    }


  }
  currentUser: any = {};
  repLink: any
  printReport() {
    let parm = {};
    parm['VisitSerial'] = this.visitSerial;
    parm['PatCode'] = this.patCode;
    parm['RegPatServiceSerial'] = this.regPatServiceSerial;
    parm['EmrHtmlReportSerial'] = this.emrHtmlReportSerial;
    parm['EmrHtmlTemplatesSerial'] = this.emrHtmlTemplateSerial;
    if (this.serviceType = 1) {
      parm['ReportType'] = 1;   // Lab

    } else {
      parm['ReportType'] = 100;   // rad

    }
    parm['ReportNameAr'] = "تقرير المريض";
    parm['ReportNameEn'] = "Patient Report";
    this.devExpressHelperComponent.showReport(parm, 'DoctorReports', 'UltrasoundReport', 'Reports.Doctor.UltrasoundReport,DoctorReports');

  }

  ///////////////AddNew Report
  newReportForServiceFlag: boolean = false;
  addNewReport() {
    this.newReportForServiceFlag = true

  }
}
